"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaQueryOnly = exports.mediaQueryBelow = exports.mediaQueryAbove = void 0;

var mediaQueryAbove = function mediaQueryAbove(breakpoints, index) {
  return "only screen and (min-width: ".concat(breakpoints[index], ")");
};

exports.mediaQueryAbove = mediaQueryAbove;

var mediaQueryBelow = function mediaQueryBelow(breakpoints, index) {
  return "only screen and (max-width: calc(".concat(breakpoints[index], " - 1px))");
};

exports.mediaQueryBelow = mediaQueryBelow;

var mediaQueryOnly = function mediaQueryOnly(breakpoints, index) {
  if (index === breakpoints.length - 1) {
    return mediaQueryAbove(breakpoints, index);
  }

  return "only screen and (min-width: ".concat(breakpoints[index], ") and (max-width: calc(").concat(breakpoints[index + 1], " - 1px))");
};

exports.mediaQueryOnly = mediaQueryOnly;